import type { ChecklistItem } from '../types/Checklist';

export const CHECKLIST_ITEMS: ChecklistItem[] = [
  // 1. Gjerder og Porter
  {
    id: '1.1',
    category: '1. Gjerder og Porter',
    checkPoint: 'Visuell inspeksjon av gjerder (skader, integritet, festepunkter)',
    frequency: 'Årlig',
    status: null,
    notes: '',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Visuell inspeksjon av gjerder (skader, integritet, festepunkter)',
    completed: false
  },
  {
    id: '1.2',
    category: '1. Gjerder og Porter',
    checkPoint: 'Visuell inspeksjon av gjerdestolper (stabilitet, skader)',
    frequency: 'Årlig',
    status: null,
    notes: '',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Visuell inspeksjon av gjerdestolper (stabilitet, skader)',
    completed: false
  },
  {
    id: '1.3',
    category: '1. Gjerder og Porter',
    checkPoint: 'Visuell inspeksjon av porter (funksjon, lås, skader)',
    frequency: 'Årlig',
    status: null,
    notes: '',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Visuell inspeksjon av porter (funksjon, lås, skader)',
    completed: false
  },
  {
    id: '1.4',
    category: '1. Gjerder og Porter',
    checkPoint: 'Kontroller at lovpålagte merker/låser er på plass (på gjerder/porter)',
    frequency: 'Årlig',
    status: null,
    notes: '',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Kontroller at lovpålagte merker/låser er på plass (på gjerder/porter)',
    completed: false
  },
  {
    id: '1.5',
    category: '1. Gjerder og Porter',
    checkPoint: 'Sjekk og vurder behov for erstatning av ødelagte/manglende skilt/advarsler',
    frequency: 'Årlig ($, foreslå)',
    status: null,
    notes: '',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Sjekk og vurder behov for erstatning av ødelagte/manglende skilt/advarsler',
    completed: false
  },
  // 2. Solcellepaneler (PV Moduler)
  {
    id: '2.1',
    category: '2. Solcellepaneler (PV Moduler)',
    checkPoint: 'Sjekk generell tilstand fra bakkenivå (glass, ramme, bakside, koblingsboks – se etter sprekker, misfarging, løse deler, fysiske skader)',
    frequency: 'Halvårlig',
    status: null,
    notes: 'Vurder også unormalt mye smuss, tegn til hot-spots (visuelt).',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Sjekk generell tilstand fra bakkenivå (glass, ramme, bakside, koblingsboks – se etter sprekker, misfarging, løse deler, fysiske skader)',
    completed: false
  },
  {
    id: '2.2',
    category: '2. Solcellepaneler (PV Moduler)',
    checkPoint: 'Vurder behov for rengjøring av moduloverflate',
    frequency: 'Ved behov ($, foreslå)',
    status: null,
    notes: 'Estimer tap pga. smuss, type smuss.',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Vurder behov for rengjøring av moduloverflate',
    completed: false
  },
  {
    id: '2.3',
    category: '2. Solcellepaneler (PV Moduler)',
    checkPoint: 'Termisk analyse av moduler (100% av moduler i området)',
    frequency: 'Årlig',
    status: null,
    notes: 'Se etter hot-spots, ujevn temperaturfordeling.',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Termisk analyse av moduler (100% av moduler i området)',
    completed: false
  },
  {
    id: '2.4',
    category: '2. Solcellepaneler (PV Moduler)',
    checkPoint: 'Måling av strengens åpen kretsspenning (hvis under-ytelse er påvist for strenger i området, 10% av disse)',
    frequency: 'Årlig ($, ved behov)',
    status: null,
    notes: 'Spesifiser hvilke strenger som måles.',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Måling av strengens åpen kretsspenning (hvis under-ytelse er påvist for strenger i området, 10% av disse)',
    completed: false
  },
  // 3. Montagestruktur/Stativ
  {
    id: '3.1',
    category: '3. Montagestruktur/Stativ',
    checkPoint: 'Kontroll av status og tiltrekking av muttere/bolter (stikkprøver) fra bakkenivå',
    frequency: 'Årlig',
    status: null,
    notes: 'Se etter løse fester, deformasjoner.',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Kontroll av status og tiltrekking av muttere/bolter (stikkprøver) fra bakkenivå',
    completed: false
  },
  {
    id: '3.2',
    category: '3. Montagestruktur/Stativ',
    checkPoint: 'Visuell inspeksjon av erosjon og korrosjon (representativt utvalg i området) fra bakkenivå',
    frequency: 'Halvårlig',
    status: null,
    notes: 'Se etter rust, galvanisk korrosjon, skader på overflatebehandling.',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Visuell inspeksjon av erosjon og korrosjon (representativt utvalg i området) fra bakkenivå',
    completed: false
  },
  {
    id: '3.3',
    category: '3. Montagestruktur/Stativ',
    checkPoint: 'Vurder behov for vedlikehold av montasjestruktur (iht. produsentens retningslinjer)',
    frequency: 'Halvårlig',
    status: null,
    notes: 'Noter eventuelle spesifikke tiltak.',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Vurder behov for vedlikehold av montasjestruktur (iht. produsentens retningslinjer)',
    completed: false
  },
  {
    id: '3.4',
    category: '3. Montagestruktur/Stativ',
    checkPoint: 'Kontinuitetssjekk av jordingssystem for stativer i området',
    frequency: 'Årlig ($, foreslå)',
    status: null,
    notes: 'Mål verdier, sjekk koblinger, korrosjon ved jordingspunkter.',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Kontinuitetssjekk av jordingssystem for stativer i området',
    completed: false
  },
  // 4. Invertere i Området
  {
    id: '4.1',
    category: '4. Invertere i Området',
    checkPoint: 'Visuell sjekk av enhetens status (display, LED-indikatorer, ytre tilstand)',
    frequency: 'Ved hvert besøk (ref. Daglig remote)',
    status: null,
    notes: 'Se etter feilkoder, unormale lyder, skader på kabinett.',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Visuell sjekk av enhetens status (display, LED-indikatorer, ytre tilstand)',
    completed: false
  },
  {
    id: '4.2',
    category: '4. Invertere i Området',
    checkPoint: 'Kontroll av beskyttelsesutstyr (visuelt, funksjonstest hvis relevant og sikkert)',
    frequency: 'Halvårlig',
    status: null,
    notes: '',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Kontroll av beskyttelsesutstyr (visuelt, funksjonstest hvis relevant og sikkert)',
    completed: false
  },
  {
    id: '4.3',
    category: '4. Invertere i Området',
    checkPoint: 'Sjekk/bytt filtre (hvis aktuelt), sjekk trykkmålere (hvis aktuelt), MOVs (visuelt), DC vifter (funksjon, støy), tetningslister (tilstand), AC kontaktor (visuelt, tegn til slitasje)',
    frequency: 'Halvårlig (oftere ved behov)',
    status: null,
    notes: 'Vurder støvakkumulering, slitasje, skader.',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Sjekk/bytt filtre (hvis aktuelt), sjekk trykkmålere (hvis aktuelt), MOVs (visuelt), DC vifter (funksjon, støy), tetningslister (tilstand), AC kontaktor (visuelt, tegn til slitasje)',
    completed: false
  },
  {
    id: '4.4',
    category: '4. Invertere i Området',
    checkPoint: 'Kontroll av tiltrekking skruer og muttere (eksternt, lett tilgjengelig på kabinett/fester)',
    frequency: 'Halvårlig',
    status: null,
    notes: '',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Kontroll av tiltrekking skruer og muttere (eksternt, lett tilgjengelig på kabinett/fester)',
    completed: false
  },
  {
    id: '4.5',
    category: '4. Invertere i Området',
    checkPoint: 'Rengjør støv fra inverterens kjøleribber (eksternt)',
    frequency: 'Halvårlig',
    status: null,
    notes: 'Sikre god luftgjennomstrømning.',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Rengjør støv fra inverterens kjøleribber (eksternt)',
    completed: false
  },
  {
    id: '4.6',
    category: '4. Invertere i Området',
    checkPoint: 'Kontroller at lovpålagte merker/låser er på plass på inverterkabinett',
    frequency: 'Årlig',
    status: null,
    notes: '',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Kontroller at lovpålagte merker/låser er på plass på inverterkabinett',
    completed: false
  },
  // 5. Kabler og Koblingsbokser
  {
    id: '5.1',
    category: '5. Kabler og Koblingsbokser',
    checkPoint: 'Generell status på kabelføring fra bakkenivå (skader, oppheng, beskyttelse, avisolering, strekkavlastning)',
    frequency: 'Årlig',
    status: null,
    notes: 'Se etter gnagerskader, klemskader, UV-skader, kabler på bakken.',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Generell status på kabelføring fra bakkenivå (skader, oppheng, beskyttelse, avisolering, strekkavlastning)',
    completed: false
  },
  {
    id: '5.2',
    category: '5. Kabler og Koblingsbokser',
    checkPoint: 'Visuell inspeksjon av koblingsbokser (pakninger, skader på kabinett, tegn til inntrengning av fukt/støv)',
    frequency: 'Halvårlig (ref "Low voltage panels")',
    status: null,
    notes: 'Se etter korrosjon internt hvis inspeksjon åpner boksen.',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Visuell inspeksjon av koblingsbokser (pakninger, skader på kabinett, tegn til inntrengning av fukt/støv)',
    completed: false
  },
  {
    id: '5.3',
    category: '5. Kabler og Koblingsbokser',
    checkPoint: 'Inspeksjon av hovedkabler for tiltrekking i koblingsbokser (visuelt, tegn til misfarging/varme)',
    frequency: 'Halvårlig (S) (ref "Low voltage panels")',
    status: null,
    notes: '',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Inspeksjon av hovedkabler for tiltrekking i koblingsbokser (visuelt, tegn til misfarging/varme)',
    completed: false
  },
  {
    id: '5.4',
    category: '5. Kabler og Koblingsbokser',
    checkPoint: 'Termisk analyse av strengbokser (100% av bokser i området)',
    frequency: 'Årlig',
    status: null,
    notes: 'Se etter hot-spots som indikerer løse koblinger eller defekter.',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Termisk analyse av strengbokser (100% av bokser i området)',
    completed: false
  },
  {
    id: '5.5',
    category: '5. Kabler og Koblingsbokser',
    checkPoint: 'Vurder behov for tiltrekkingskontroll av ledninger i koblingsbokser',
    frequency: 'Årlig ($, "Not applicable" - avklar)',
    status: null,
    notes: 'Foreslå/fakturer hvis relevant og avklart.',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Vurder behov for tiltrekkingskontroll av ledninger i koblingsbokser',
    completed: false
  },
  {
    id: '5.6',
    category: '5. Kabler og Koblingsbokser',
    checkPoint: 'Kontroller at lovpålagte merker/låser er på plass på koblingsbokser',
    frequency: 'Årlig',
    status: null,
    notes: '',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Kontroller at lovpålagte merker/låser er på plass på koblingsbokser',
    completed: false
  },
  // 6. Sensorer og Måleutstyr
  {
    id: '6.1',
    category: '6. Sensorer og Måleutstyr',
    checkPoint: 'Pyranometer: Rengjøring av glasskuppel/sensorflate',
    frequency: 'Ved hvert besøk / Halvårlig',
    status: null,
    notes: 'Fjern smuss, fugleskitt, sjekk for skygge fra vegetasjon/objekter.',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Pyranometer: Rengjøring av glasskuppel/sensorflate',
    completed: false
  },
  {
    id: '6.2',
    category: '6. Sensorer og Måleutstyr',
    checkPoint: 'Pyranometer: Visuell sjekk av enhet, kabler, vater (hvis aktuelt), feste',
    frequency: 'Halvårlig',
    status: null,
    notes: 'Se etter skader, løse koblinger, korrekt montering.',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Pyranometer: Visuell sjekk av enhet, kabler, vater (hvis aktuelt), feste',
    completed: false
  },
  {
    id: '6.3',
    category: '6. Sensorer og Måleutstyr',
    checkPoint: 'Temperatursensorer (modul/omgivelse): Visuell sjekk, feste, kabler',
    frequency: 'Halvårlig (implisitt i re-kalibrering)',
    status: null,
    notes: '',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Temperatursensorer (modul/omgivelse): Visuell sjekk, feste, kabler',
    completed: false
  },
  {
    id: '6.4',
    category: '6. Sensorer og Måleutstyr',
    checkPoint: 'Vurder behov for re-kalibrering av pyranometer og temperatursensorer',
    frequency: 'Hvert 2. år ($, foreslå)',
    status: null,
    notes: 'Planlegg iht. produsentens spesifikasjoner.',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Vurder behov for re-kalibrering av pyranometer og temperatursensorer',
    completed: false
  },
  // 7. Generelt for Området
  {
    id: '7.1',
    category: '7. Generelt for Området',
    checkPoint: 'Generell visuell inspeksjon av hele området (ryddighet, uønskede gjenstander, tegn til hærverk)',
    frequency: 'Årlig',
    status: null,
    notes: '',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Generell visuell inspeksjon av hele området (ryddighet, uønskede gjenstander, tegn til hærverk)',
    completed: false
  },
  {
    id: '7.2',
    category: '7. Generelt for Området',
    checkPoint: 'Inspeksjon av interne dreneringssystemer og vannkanaler i området',
    frequency: 'Ved hvert besøk',
    status: null,
    notes: 'Se etter blokkeringer, erosjon, skader, funksjonalitet.',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Inspeksjon av interne dreneringssystemer og vannkanaler i området',
    completed: false
  },
  {
    id: '7.3',
    category: '7. Generelt for Området',
    checkPoint: 'Inspeksjon av adkomstveier/stier innenfor og til området (tilstand, fremkommelighet)',
    frequency: 'Ved hvert besøk / Ved behov ($, foreslå)',
    status: null,
    notes: 'Se etter hull, gjengroing, hindringer.',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Inspeksjon av adkomstveier/stier innenfor og til området (tilstand, fremkommelighet)',
    completed: false
  },
  {
    id: '7.4',
    category: '7. Generelt for Området',
    checkPoint: 'Vurdering av vegetasjon (gresshøyde, busker, trær – mtp. skygge på paneler, adkomst, brannfare, krav i reguleringsplan/LEMP)',
    frequency: 'Ved hvert besøk / Ved behov (S, $, foreslå)',
    status: null,
    notes: 'Noter behov for klipping, rydding, fjerning.',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Vurdering av vegetasjon (gresshøyde, busker, trær – mtp. skygge på paneler, adkomst, brannfare, krav i reguleringsplan/LEMP)',
    completed: false
  },
  {
    id: '7.5',
    category: '7. Generelt for Området',
    checkPoint: 'Sjekk for erosjon eller andre endringer i grunnforhold i området',
    frequency: 'Ved hvert besøk / Halvårlig',
    status: null,
    notes: 'Se etter utglidninger, setninger, sprekker i bakken.',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Sjekk for erosjon eller andre endringer i grunnforhold i området',
    completed: false
  },
  {
    id: '7.6',
    category: '7. Generelt for Området',
    checkPoint: '(Kun for Område 5) Inspeksjon av Gunnarsbekken dam',
    frequency: 'Halvårlig',
    status: null,
    notes: '',
    images: [],
    timestamp: '',
    inspectors: [],
    text: '(Kun for Område 5) Inspeksjon av Gunnarsbekken dam',
    completed: false
  },
  {
    id: '7.7',
    category: '7. Generelt for Området',
    checkPoint: 'Kontroll og tilstand på eventuelt distribuert nødutstyr i området (f.eks. brannslukkere)',
    frequency: 'Årlig',
    status: null,
    notes: 'Sjekk trykk, serviceetikett, tilgjengelighet.',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Kontroll og tilstand på eventuelt distribuert nødutstyr i området (f.eks. brannslukkere)',
    completed: false
  },
  // 8. HMS og Sikkerhet
  {
    id: '8.1',
    category: '8. HMS og Sikkerhet',
    checkPoint: 'Er anleggsregler/HMS-rutiner fulgt under inspeksjonen av området?',
    frequency: 'Ved hvert besøk',
    status: null,
    notes: '',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Er anleggsregler/HMS-rutiner fulgt under inspeksjonen av området?',
    completed: false
  },
  {
    id: '8.2',
    category: '8. HMS og Sikkerhet',
    checkPoint: 'Identifiserte nye farer eller HMS-risikoer i området?',
    frequency: 'Ved hvert besøk',
    status: null,
    notes: 'Rapporteres videre iht. interne rutiner.',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Identifiserte nye farer eller HMS-risikoer i området?',
    completed: false
  },
  {
    id: '8.3',
    category: '8. HMS og Sikkerhet',
    checkPoint: 'Generell sikkerhetstilstand i området (snublerisiko, skarpe kanter, etc.)',
    frequency: 'Ved hvert besøk',
    status: null,
    notes: '',
    images: [],
    timestamp: '',
    inspectors: [],
    text: 'Generell sikkerhetstilstand i området (snublerisiko, skarpe kanter, etc.)',
    completed: false
  },
]; 